export default __webpack_public_path__ + "static/media/Icon-date-new.6064b2d3.svg";